module.exports = __webpack_public_path__ + "img/public.69e37172.png";